module.exports = __webpack_public_path__ + "static/quiz_stage_9_bg-b8ac4151d7ef5976a7a69cda3db12186.svg";